export default __webpack_public_path__ + "static/help_05_02_1-19a4d7e26f82d98ab8840cc5e983ed07.png";